enum FORMIK_VALIDATION {
  PASSWORD_MIN = 8,
  USER_NAME_MIN = 2,
  USER_NAME_MAX = 35,
  USER_SURNAME_MIN = 2,
  USER_SURNAME_MAX = 35,
  KNOWLEDGE_AREA_NAME_MAX = 50,
  KNOWLEDGE_AREA_LEVEL_NAME_MAX = 45,
  ORGANIZATION_NAME_MAX = 55,
}
export { FORMIK_VALIDATION };
